var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customid === 2)?_c('div',{staticClass:"card-form",on:{"click":_vm.gotoMaintenancePlan}},[_c('img',{attrs:{"src":require("../../assets/icon-home/maintenance_plan.svg")}}),_c('div',{staticClass:"group-text"},[_c('h1',[_vm._v(_vm._s(_vm.$t("maintenance_plan.maintenance_plan")))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }